export default __webpack_public_path__ + "a82ef99343fe2716ffbb6b6ebfe385c7.png";